import { LocationConfiguration } from '@/modules/location/domain/LocationConfigurationSchema.ts';

export function prefillLegacyFactoryId<T extends { loadingLocation?: LocationConfiguration }>(
    defaultValues?: T,
    legacyFactoryId?: number | null
): T | undefined {
    if (!defaultValues?.loadingLocation) {
        return defaultValues;
    }

    return {
        ...defaultValues,
        loadingLocation: {
            ...defaultValues.loadingLocation,
            location: { ...defaultValues.loadingLocation.location, legacyFactoryId },
        },
    };
}
